import React from "react";
import { Languages } from "../../../../components/languages";
import { Roles } from "../../../../auth/rolesPermissions";
import { PageTitle, UIActionButton, UIConfirmPopup, UIResponsePopup } from "../../../../components/guiElements";
import { GetOrders, CancelOrder } from "../../../../api/warehouseAPI";
import { formatDateTime } from "../../../../helpers/helper";
import { warehouseUIProfiles } from "../../../../auth/warehouseProfiles";
import { WarehouseFilters, WarehouseTable, WarehouseOrderDetails } from "../../Components/warehouseComponents";

//export default class WarehouseOrderHistory extends React.Component {
export default class StandardDealerOrderHistory extends React.Component {


    constructor(props) {
        super(props);
        this.history = props.history;
        this.getDataOrders = this.getDataOrders.bind(this);
        this.buildEntriesOrders = this.buildEntriesOrders.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleFilterSearch = this.handleFilterSearch.bind(this);
        this.parseNumberFilter = this.parseNumberFilter.bind(this);

        this.profile = props.profile;

        this.uc = props.userContext;
        this.uiProfile = warehouseUIProfiles[this.uc?.userRole] || warehouseUIProfiles.DEFAULT;
        this.le = Languages.Warehouse.OrderHistory[Languages.selectedLanguage];
        this.leMain = Languages.Main[Languages.selectedLanguage];
        this._isMounted = false;

        this.configs = { filters: this.getFiltersConfig(), };

        this.header = this.getOrderHeaders();

        const filters = this.createInitialFilters();

        this.appliedFilters = filters;


        this.state = {
            entries: [],
            filters: filters,
            orders: [],
            totals: [],
            loading: true,
            cancellingOrderId: null,
            orderPendingCancellation: null,
            cancelOrderResult: null,
            refreshOrdersAfterCancel: false,

            orderDetailsById: {}, /*Contiene i dettagli già caricati*/
            loadingOrderDetailsById: {}, /*Quale ordine sta caricando i dettagli*/
            orderDetailsErrorsById: {},/*Contiene l'eventuale errore associato a ciascun ordine*/
            selectedOrderDetails: null,

            pageNumber: 1,
            pageSize: 10,
            sortField: "DATE",
            sortDirection: "desc",
            totalItems: 0,
            totalPages: 0,

            profileReady: false,
            profileError: "",
        };
    }

    //#region Configuration Builders

    getOrderHeaders() {

        const headers = [
            { field: "displayNumber", label: this.le.list[0], className: "cell-center" },
            { field: "date", label: this.le.list[1], className: "cell-center" },
            { field: "shipmentReferenceID", label: this.le.list[2], className: "cell-center" },
            { field: "deliveryName", label: this.le.list[3], className: "cell-center" },
            { field: "carrierCode", label: this.le.list[4], className: "cell-center" },
            { field: "status", label: this.le.list[5], className: "cell-center" },
        ]

        if (this.uiProfile.showDealerColumn) {
            headers.push(
                {
                    field: "dealerCode",
                    label: this.le.list[6],
                    className: "cell-center"
                },
            );
        }

        headers.push({
            field: "actions",
            label: this.le.list[7],
            className: "cell-actions",
            type: "actions",
            render: (_, order) => this.renderOrderActions(order)
        });

        return headers;

    }

    getFiltersConfig() {
        return {
            number: { type: "text", width: "20%" },
            ...(this.uiProfile.showDealerColumn && {
                dealerCode: { type: "text", width: "20%" }
            }),
            filterButton: { type: "button" },
            clearButton: { type: "clearButton" },
        };
    }

    createInitialFilters() {
        const filters = {};

        Object.keys(this.configs.filters).forEach(key => {
            filters[key] = this.configs.filters[key].type == "checkbox" ? false : "";
        });

        return filters;
    }

    //#endregion

    componentDidMount() {
        this._isMounted = true;

        this.setState({
            profileReady: true,
            profileError: ""
        }, () => {
            if (this._isMounted) {
                this.getDataOrders(this.state.filters);
            }
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    // #region Get Order data

    GetOrderDisplayNumber = (number, dealerCode) => {
        if (!number) {
            return "";
        }

        if (!dealerCode) {
            return number;
        }

        const prefix = `${dealerCode}_`;

        return number.startsWith(prefix)
            ? number.substring(prefix.length)
            : number;
    }

    getOrderRowId = order => {
        return `${order.dealerCode || "NO_DEALER"}_${order.number}`;
    };

    buildEntriesOrders = (orders) => {
        let entries = [];

        for (let i = 0; i < orders.length; i++) {
            let order = orders[i];

            let entry = {
                rowId: this.getOrderRowId(order),
                number: order.number || "",
                displayNumber: this.GetOrderDisplayNumber(order.number, order.dealerCode),
                date: formatDateTime(order.date),
                shipmentReferenceID: order.shipmentReferenceID?.toString() ?? "",
                customerCode: order.customerCode || "",
                customerName: order.customerName || "",
                deliveryName: order.deliveryName || "",
                carrierCode: order.carrierCode || "",
                status: order.status ?? "",
                dealerCode: order.dealerCode || "",
            };

            entries.push(entry);
        }

        return entries;
    }

    parseNumberFilter(numberValue) {
        return (numberValue || "")
            .split(";")
            .map(number => number.trim())
            .filter(Boolean);
    }

    getDataOrders = async (filters) => {
        if (this._isMounted) {
            this.setState({ loading: true })
        }

        const { pageNumber, pageSize, sortField, sortDirection } = this.state;

        try {
            const numberList = this.parseNumberFilter(filters.number);
            const dealerCode = this.uc.userRole === Roles.WAREHOUSEUSER
                ? this.uc.dealerCode
                : (filters.dealerCode || null);
            const getOrderData = {
                APIKey: "",
                APISecret: "",
                Data: {
                    Number: numberList,
                    DealerCode: dealerCode,
                    Language: Languages.selectedLanguage.toUpperCase(),

                    PageNumber: pageNumber,
                    PageSize: pageSize,
                    SortField: sortField,
                    SortDirection: sortDirection,

                    IncludeDetails: false,
                    RequestFrom: null
                }
            };

            //this.props.loaderShow(0);
            const response = await GetOrders(this.uc.jwtToken, getOrderData);

            if (!this._isMounted) {
                return;
            }

            if (response.error == null) {

                const ordersResult = response?.result?.orders;
                const orders = ordersResult?.getOrdersV2Result?.data ?? [];

                let entries = this.buildEntriesOrders(orders);

                let totals = [{
                    name: 'orders',
                    val: ordersResult?.getOrdersV2Result.totalItems ?? orders.length
                }];

                this.setState({
                    entries: entries,
                    orders: orders,
                    totals: totals,
                    orderDetailsById: {},
                    loadingOrderDetailsById: {},
                    orderDetailsErrorsById: {},
                    selectedOrderDetails: null,
                    pageNumber: ordersResult?.getOrdersV2Result?.pageNumber ?? pageNumber,
                    pageSize: ordersResult?.getOrdersV2Result?.pageSize ?? pageSize,
                    totalItems: ordersResult?.getOrdersV2Result?.totalItems ?? orders.length,
                    totalPages: ordersResult?.getOrdersV2Result?.totalPages ?? 1
                });
                //this.props.loaderHide();
            } else {
                //this.props.loaderHide();
                this.props.popupErrorMessage(response.error.message);
            }
        }
        catch (error) {
            if (this._isMounted) {
                this.props.popupErrorMessage(error.message || "Impossibile caricare lo storico ordini.");
            }
        }
        finally {
            if (this._isMounted) {
                this.setState({ loading: false });
            }
        }
    }

    // #endregion Get Order Data

    handleClearFilters = () => {
        const filters = this.createInitialFilters();

        this.setState(
            {
                filters,
                pageNumber: 1
            },
            () => {
                this.getDataOrders(filters);
            }
        );
    };

    handleFilterSearch = (ev) => {
        ev.preventDefault();

        this.setState(
            { pageNumber: 1 },
            () => this.getDataOrders(this.state.filters)
        );
    }

    handleFilterChange = (e) => {
        const { name, value, type, checked } = e.target;

        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                [name]: type === "checkbox" ? checked : value
            }
        }));
    };

    handlePageChange = (pageNumber) => {
        this.setState(
            { pageNumber },
            () => this.getDataOrders(this.state.filters)
        );
    }

    handlePageSizeChange = (pageSize) => {
        this.setState(
            {
                pageSize,
                pageNumber: 1
            },
            () => this.getDataOrders(this.state.filters)
        );
    }

    //#region Order Action handlers

    closeCancelOrderResultPopup = () => {
        const shouldRefresh = this.state.refreshOrdersAfterCancel;

        this.setState(
            {
                cancelOrderResult: null,
                refreshOrdersAfterCancel: false
            },
            () => {
                if (shouldRefresh) {
                    this.getDataOrders(
                        this.state.filters
                    );
                }
            }
        );
    };

    canCancelOrder = (order) => {
        if (!order) {
            return false;
        }

        const cancellableStatuses = [
            "DA PROCESSARE"
        ];

        const normalizedStatus = String(order.status || "")
            .trim()
            .toUpperCase();

        return cancellableStatuses.includes(normalizedStatus);
    };

    requestCancelOrder = (order) => {
        if (!this.canCancelOrder(order) || this.state.cancellingOrderId != null) {
            return;
        }

        this.setState({
            orderPendingCancellation: order,
            cancelOrderResult: null
        });
    };

    closeCancelOrderPopup = () => {
        if (this.state.cancellingOrderId != null) {
            return;
        }

        this.setState({
            orderPendingCancellation: null
        });
    };

    confirmCancelOrder = () => {
        const order = this.state.orderPendingCancellation;

        if (!order) {
            return;
        }

        this.handleCancelOrder(order);
    };

    getCancelOrderResultConfig = result => {
        if (!result) {
            return null;
        }


        if (result.type === "accepted") {
            return {
                accepted: true,
                title: this.le.ResponsePopup.acceptedTitle,
                message:
                    result.message ||
                    this.le.ResponsePopup.acceptedMessage,
                closeText: this.le.ResponsePopup.close
            };
        }

        if (result.type === "rejected") {
            return {
                accepted: false,
                title: this.le.ResponsePopup.rejectedTitle,
                message:
                    result.message ||
                    this.le.ResponsePopup.rejectedMessage,
                closeText: this.le.ResponsePopup.close
            };
        }

        return null;
    };

    handleCancelOrder = async order => {
        if (!this.canCancelOrder(order) || this.state.cancellingOrderId != null) {
            return;
        }

        const originalOrderNumber = order.number;
        const shipmentReferenceID =
            order.shipmentReferenceID;

        if (!originalOrderNumber || !shipmentReferenceID) {
            this.setState(
                {
                    orderPendingCancellation: null
                },
                () => {
                    this.props.popupErrorMessage(
                        this.le.errors.invalidOrder
                    );
                }
            );

            return;
        }

        try {
            this.setState({
                cancellingOrderId:
                    shipmentReferenceID
            });

            const request = {
                APIKey: "",
                APISecret: "",
                Data: {
                    OrderReference:
                        originalOrderNumber
                }
            };

            const response = await CancelOrder(this.uc.jwtToken, request);

            if (!response) {
                throw new Error(this.le.errors.cancelOrderError);
            }

            if (response.error != null) {
                throw new Error(
                    response.error.message ||
                    this.le.errors.cancelOrderError
                );
            }

            const cancelOrderData = response?.result?.order;

            if (!cancelOrderData) {
                throw new Error(
                    this.le.errors.cancelOrderError
                );
            }

            const isSuccess = cancelOrderData.success === true;

            const resultMessage = cancelOrderData.message || null;

            if (this._isMounted) {
                this.setState({
                    orderPendingCancellation: null,

                    cancelOrderResult: {
                        type: isSuccess
                            ? "accepted"
                            : "rejected",

                        message: resultMessage,

                        statusCode:
                            cancelOrderData.statusCode,

                        generixResult:
                            cancelOrderData.generixResult
                    },

                    refreshOrdersAfterCancel:
                        isSuccess
                });
            }
        } catch (error) {
            if (this._isMounted) {
                this.setState(
                    {
                        orderPendingCancellation: null,
                        cancelOrderResult: null,
                        refreshOrdersAfterCancel: false
                    },
                    () => {
                        this.props.popupErrorMessage(
                            error?.message ||
                            this.le.errors
                                .cancelOrderError
                        );
                    }
                );
            }
        } finally {
            if (this._isMounted) {
                this.setState({
                    cancellingOrderId: null
                });
            }
        }
    };

    //#endregion

    handleOpenOrderDetails = order => {
        if (!order || !order.rowId) {
            return;
        }

        const orderId = order.rowId;

        this.setState(
            {
                selectedOrderDetails: order
            },
            () => {
                const detailsAlreadyLoaded =
                    Object.prototype.hasOwnProperty.call(
                        this.state.orderDetailsById,
                        orderId
                    );

                const isLoading =
                    this.state.loadingOrderDetailsById[
                    orderId
                    ] === true;

                if (
                    !detailsAlreadyLoaded &&
                    !isLoading
                ) {
                    this.loadOrderDetails(order);
                }
            }
        );
    };

    handleCloseOrderDetails = () => {
        this.setState({
            selectedOrderDetails: null
        });
    };

    loadOrderDetails = async order => {
        const orderId = order.rowId;

        if (this.state.loadingOrderDetailsById[orderId]) {
            return;
        }

        this.setState(prevState => ({
            loadingOrderDetailsById: {
                ...prevState.loadingOrderDetailsById,
                [orderId]: true
            },

            orderDetailsErrorsById: {
                ...prevState.orderDetailsErrorsById,
                [orderId]: null
            }
        }));

        try {
            const getOrderData = {
                APIKey: "",
                APISecret: "",

                Data: {
                    Number: [order.number],

                    DealerCode:
                        order.dealerCode || null,

                    Language:
                        Languages.selectedLanguage.toUpperCase(),

                    PageNumber: 1,
                    PageSize: 1,
                    SortField: "DATE",
                    SortDirection: "desc",

                    IncludeDetails: true,

                    RequestFrom: null
                }
            };

            const response = await GetOrders(this.uc.jwtToken, getOrderData);

            if (!this._isMounted) {
                return;
            }

            if (!response) {
                throw new Error(this.le.errors.orderDetailsError);
            }

            if (response.error != null) {
                throw new Error(response.error.message || this.le.errors.orderDetailsError);
            }

            const returnedOrders = response?.result?.orders?.getOrdersV2Result?.data ?? [];

            const returnedOrder =
                returnedOrders.find(item =>
                    item.number === order.number &&
                    (
                        !order.dealerCode ||
                        item.dealerCode === order.dealerCode
                    )
                );

            if (!returnedOrder) {
                throw new Error(this.le.errors.orderDetailsNotFound);
            }

            const orderDetails = returnedOrder.orderDetails ?? [];

            if (this._isMounted) {
                this.setState(prevState => ({
                    orderDetailsById: {
                        ...prevState.orderDetailsById,
                        [orderId]: orderDetails
                    }
                }));
            }
        } catch (error) {
            if (this._isMounted) {
                this.setState(prevState => ({
                    orderDetailsErrorsById: {
                        ...prevState.orderDetailsErrorsById,

                        [orderId]:
                            error?.message ||
                            this.le.errors.orderDetailsError
                    }
                }));
            }
        } finally {
            if (this._isMounted) {
                this.setState(prevState => ({
                    loadingOrderDetailsById: {
                        ...prevState.loadingOrderDetailsById,
                        [orderId]: false
                    }
                }));
            }
        }
    };

    //#region render Order Actions

    renderOrderActions = order => {
        const orderId = order.rowId;

        const isLoadingDetails = this.state.loadingOrderDetailsById[orderId] === true;

        const actions = [];

        actions.push(
            <UIActionButton
                key="details"
                icon="fa-solid fa-clipboard-list"
                label={this.le.showDetails}
                loading={isLoadingDetails}
                onClick={() =>
                    this.handleOpenOrderDetails(order)
                }
            />
        );

        if (this.canCancelOrder(order)) {
            const isCancelling =
                this.state.cancellingOrderId ===
                order.shipmentReferenceID;

            actions.push(
                <UIActionButton
                    key="cancel"
                    icon="fa-sharp fa-solid fa-x"
                    label={
                        isCancelling
                            ? this.le.cancellingOrder
                            : this.le.cancelOrder
                    }
                    danger={true}
                    loading={isCancelling}
                    onClick={() =>
                        this.requestCancelOrder(order)
                    }
                />
            );
        }

        return (
            <div className="table-row-actions">
                {actions}
            </div>
        );
    };

    //#endregion

    render() {

        if (!this.state.profileReady) {
            return (
                <div>
                    {this.state.profileError || "Caricamento configurazione warehouse..."}
                </div>
            );
        }



        const cancelOrderResultConfig = this.getCancelOrderResultConfig(this.state.cancelOrderResult);

        const selectedOrder = this.state.selectedOrderDetails;

        const selectedOrderId = selectedOrder
            ? selectedOrder.rowId
            : null;

        return <div className="page-order-history">
            <PageTitle icon="../images/mainMenu/Orders.png" title={Languages.getSection('Main').menuLabels.ordersHistory} />

            <fieldset className="warehouse-loading-controls"  disabled={this.state.loading}>
                <WarehouseFilters
                    config={this.profile.orderHistory.components.filters}
                    fields={this.configs.filters}
                    values={this.state.filters}
                    labels={this.le.filters.items}
                    onChange={this.handleFilterChange}
                    onSearch={this.handleFilterSearch}
                    onClear={this.handleClearFilters}
                />
            </fieldset>

            <div className="page-content">
                <WarehouseTable
                    config={this.profile.orderHistory.components.table}
                    loading={this.state.loading}
                    loadingMessage={this.le.loadingMessage}
                    headers={this.header}
                    items={this.state.entries}
                    rowKey="rowId"
                    serverSidePagination={true}
                    currentPage={this.state.pageNumber}
                    itemsPerPage={this.state.pageSize}
                    totalItems={this.state.totalItems}
                    totalPages={this.state.totalPages}
                    onPageChange={this.handlePageChange}
                    onItemsPerPageChange={this.handlePageSizeChange}
                />

                {selectedOrder && (
                    <WarehouseOrderDetails
                        config={this.profile.orderHistory.components.details}
                        items={this.state.orderDetailsById[selectedOrderId] || []}
                        loading={this.state.loadingOrderDetailsById[selectedOrderId] === true}
                        error={this.state.orderDetailsErrorsById[selectedOrderId] || null}
                        orderNumber={selectedOrder.displayNumber || selectedOrder.number || selectedOrder.orderNumber}
                        onRetry={() => this.loadOrderDetails(selectedOrder)}
                        onClose={this.handleCloseOrderDetails}
                    />
                )}
            </div>

            {this.state.orderPendingCancellation && (
                <UIConfirmPopup
                    title={this.le.confirmPopup.cancelOrderTitle}
                    message={this.le.confirmPopup.cancelOrderConfirm}
                    highlightedValue={this.state.orderPendingCancellation.displayNumber}
                    showCancelButton={true}
                    confirmText={this.le.confirmPopup.confirm}
                    cancelText={this.le.confirmPopup.cancel}
                    loadingText={this.le.confirmPopup.cancellingOrder}
                    icon="fa-solid fa-ban"
                    danger={true}
                    loading={this.state.cancellingOrderId === this.state.orderPendingCancellation.shipmentReferenceID}
                    onConfirm={this.confirmCancelOrder}
                    onCancel={this.closeCancelOrderPopup}
                />
            )}

            {cancelOrderResultConfig && (
                <UIResponsePopup
                    accepted={cancelOrderResultConfig.accepted}
                    title={cancelOrderResultConfig.title}
                    message={cancelOrderResultConfig.message}
                    closeText={cancelOrderResultConfig.closeText}
                    onClose={this.closeCancelOrderResultPopup}
                />
            )}

        </div>;
    }
}



